'use client';

import { useEffect } from 'react';
import { captureAttributionOnce } from '@/lib/analytics/attribution';

/**
 * Records the traffic source on the first page load of a session.
 *
 * Mounted in the locale layout so it runs before the visitor reaches the audit
 * form. Capturing at submit time would be too late: by then the referrer is the
 * internal page they came from.
 */
export function AttributionCapture() {
  useEffect(() => {
    captureAttributionOnce();
  }, []);
  return null;
}
